import PropertyType from '../Modifiers/PropertyType.js';

// this isn't being used anywhere for now because we don't have any other border types other than color
var ThemeBlockBorderType = new PropertyType({
  name: 'BlockBorderType',
  propertyFromApi: 'block-border-type',
  defaultValue: 'color'
}, 'theme');

// this isn't being used anywhere for now because we don't have any other border types other than color
var FormBlockBorderType = new PropertyType({
  name: 'BlockBorderType',
  propertyFromApi: 'block-border-type',
  defaultValue: 'color'
}, 'form');

export { FormBlockBorderType, ThemeBlockBorderType };
//# sourceMappingURL=BlockBorderType.js.map
